import { Bookmark, ShoppingBag, TrendingUp, ArrowRight } from "lucide-react";

export default function RightSidebar({ savedGifts = [] }) {
  const saved = savedGifts.filter((gift) => gift.status === "saved");
  const bought = savedGifts.filter((gift) => gift.status === "bought");

  return (
    <section className="myGiftsBottomSection">
      <div className="myGiftsBottomHeader">
        <h2>My Gifts</h2>
        <p>Track your saved gift ideas, bought gifts, and trending inspiration.</p>
      </div>

      <div className="myGiftsBoxGrid">
        <div className="myGiftSquareBox savedBox">
          <div className="myGiftBoxIcon">
            <Bookmark size={26} />
          </div>
          <h3>Saved</h3>
          <strong>{saved.length}</strong>
          <p>Gift ideas you saved for later.</p>
        </div>

        <div className="myGiftSquareBox boughtBox">
          <div className="myGiftBoxIcon">
            <ShoppingBag size={26} />
          </div>
          <h3>Already Bought</h3>
          <strong>{bought.length}</strong>
          <p>Gifts you already marked as bought.</p>
        </div>

        <a
          className="myGiftSquareBox trendingBox"
          href="https://www.amazon.com/s?k=trending+gifts"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="myGiftBoxIcon">
            <TrendingUp size={26} />
          </div>
          <h3>Trending Gifts</h3>
          <strong>Explore</strong>
          <p>Popular gift ideas from online stores.</p>
          <span className="myGiftExplore">
            View ideas <ArrowRight size={15} />
          </span>
        </a>
      </div>
    </section>
  );
}